import { DEFAULT_TIME_FORMAT } from '@infotech-soe/erp-ui-kit';

import { NamedDomain } from '../../../../../infrastructure/schemas/storage/NamedDomain';
import {
  DateFormControlDelimiterType,
  DateTruncTo,
} from '../../../view-model/FormControlViewModel';

interface FormatAndDelimiter {
  format: string;
  delimiter: DateFormControlDelimiterType;
  truncTo: DateTruncTo;
}

const SUPPORTED_DOT_FORMATS = [
  'MM.YYYY',
  'DD.MM.YYYY',
  'DD.MM.YYYY hh:mm',
  'DD.MM.YYYY hh:mm:ss',
];

const SUPPORTED_SLASH_FORMATS = SUPPORTED_DOT_FORMATS.map(format =>
  format.replaceAll('.', '/')
);

const SUPPORTED_FORMATS = new Set([
  ...SUPPORTED_DOT_FORMATS,
  ...SUPPORTED_SLASH_FORMATS,
]);

export function getDateFormatProps(domain: NamedDomain): FormatAndDelimiter {
  const result: FormatAndDelimiter = {
    format: 'DD-MM-YYYY',
    delimiter: DateFormControlDelimiterType.DOT,
    truncTo: 'day',
  };
  if (!domain?.format) return result;
  if (!SUPPORTED_FORMATS.has(domain.format))
    throw new Error(
      'Unsupported date format in domain:' + JSON.stringify(domain)
    );
  result.delimiter = domain.format.includes('.')
    ? DateFormControlDelimiterType.DOT
    : DateFormControlDelimiterType.SLASH;
  result.format = domain.format.split(result.delimiter).join('-');

  const timeFormat = domain.format.split(' ')?.[1];
  result.truncTo = !timeFormat
    ? 'day'
    : timeFormat.length === DEFAULT_TIME_FORMAT.length
      ? 'min'
      : 'sec';

  return result;
}
